import { useEffect, useState } from "react"
import { Table, Column, FieldType, Section, Async, FieldValue } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { ProductName, useProductLoaders } from "../../../../products"
import { Data } from "../../../../../features/data-types"
import { SpecialDiscountItem } from "../../../state/types"
import { round } from "../../../../../utils/typeUtils"

type Props = {
    items: SpecialDiscountItem[]
    onCreateItem?: () => void
    onEditItem?: (productId: string) => void
    onRemoveItem?: (productId: string) => void
}

export const SpecialDiscountItemsTable = (props: Props) => {
    const { items, onCreateItem, onEditItem, onRemoveItem } = props
    const [rows, setRows] = useState<Data[]>([])
    const productLoaders = useProductLoaders()

    useEffect(() => {
        const loadRows = async () => {
            return Promise.all(items.map(async item => ({
                productId: item.productId,
                discount: `${round(item.specialDiscountYield)}%`,
                finalPrice: item.finalPrice
            })))
        }
        loadRows().then(rows => setRows(rows as Data[]))
    }, [items])

    const columns: Column[] = [
        {
            name: 'productId',
            type: FieldType.TABLE,
            table: TableName.PRODUCTS,
            label: 'Producto',
            render: (value?: FieldValue) => <Async
                loadFn={async () => {
                    const product = value ? await productLoaders().loadProduct(value as string) : undefined
                    return <ProductName product={product} />
                }}
                deps={[items]}
            />
        },
        {
            name: 'discount',
            type: FieldType.TEXT,
            label: 'Descuento'
        },
        {
            name: 'finalPrice',
            type: FieldType.PRICE,
            label: 'Precio Final'
        }
    ]

    return (
        <Section
            id='specialDiscountItems'
            space={12}
        >
            <Table
                columns={columns}
                rows={rows}
                rowId='productId'
                createIcon="plus"
                small
                onCreate={onCreateItem}
                onEdit={onEditItem ? (id) => onEditItem(id as string) : undefined}
                onRemove={onRemoveItem ? (id) => onRemoveItem(id as string) : undefined}
            />
        </Section>
    )
}
